import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { x: "2", y: "4", width: "20", height: "16", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 4v4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 8h20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 4v4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "AppWindow";
const AppWindow = memo(themed(Icon));
export {
  AppWindow
};
//# sourceMappingURL=app-window.js.map
